export default __webpack_public_path__ + "static/media/gallery-img02.59059032.jpg";